const FrontSiteBase = "/";

const FrontSiteRoutesList = {
  legacyRecordDetails: `${FrontSiteBase}legacy/:legacyRecId`,
};

export const FrontSiteRoutes = {
  ...FrontSiteRoutesList,
};
